import { Box, Grid, Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { FormSection } from "components/FormControls/FormSection";
import { SelectInput } from "components/FormControls/Select/Select";
import { TextInput } from "components/FormControls/TextInput";
import { OLSwitch } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { getCountries } from "reduxState/settings/settings";
import { useStyles } from "../SimulateCampaign.styles";

interface Props {
  fieldNamePrefix: "customer" | "referrer";
  setFieldValue: (field: string, value: any) => void;
  isAddressAttached: boolean;
}

export const AddressDetails = ({
  fieldNamePrefix,
  setFieldValue,
  isAddressAttached,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const countriesList = useAppSelector(getCountries);

  return (
    <FormSection>
      <Box className={classes.sectionHeaderContainer}>
        <Typography className={classes.title}>
          {message({ id: "addressDetails" })}
        </Typography>
        <OLSwitch
          checked={isAddressAttached}
          onChange={() =>
            setFieldValue(
              `${fieldNamePrefix}.address`,
              isAddressAttached ? undefined : {},
            )
          }
          data-test-id="address-details-switch"
        />
      </Box>
      {isAddressAttached ? (
        <Grid container spacing={12} mt={0}>
          <Grid item xs={6}>
            <TextInput
              className={classes.input}
              label={message({ id: "streetName" })}
              name={`${fieldNamePrefix}.address.street`}
              type="text"
              data-test-id="street-name"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              className={classes.input}
              label={message({ id: "buildingName" })}
              name={`${fieldNamePrefix}.address.address1`}
              type="text"
              data-test-id="building-name"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              className={classes.input}
              label={message({ id: "flatUnitName" })}
              name={`${fieldNamePrefix}.address.address2`}
              type="text"
              data-test-id="flat-unit-name"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              className={classes.input}
              label={message({ id: "stateProvince" })}
              name={`${fieldNamePrefix}.address.province`}
              type="text"
              data-test-id="state-province"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              className={classes.input}
              label={message({ id: "city" })}
              name={`${fieldNamePrefix}.address.city`}
              type="text"
              data-test-id="city"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              className={classes.input}
              label={message({ id: "postalCode" })}
              name={`${fieldNamePrefix}.address.postal`}
              type="text"
              data-test-id="postal-code"
              width="100%"
            />
          </Grid>
          <Grid item xs={12}>
            <SelectInput
              displaySearch
              items={
                countriesList?.map((country) => ({
                  id: country.code,
                  label: country.name,
                })) || []
              }
              label={message({ id: "country" })}
              name={`${fieldNamePrefix}.address.country`}
              data-test-id="country"
            />
          </Grid>
        </Grid>
      ) : null}
    </FormSection>
  );
};
